import React from 'react';
import PropTypes from 'prop-types';

export const RefreshButtonNewData = ({ onClick }) => {
    return (
        <div className="insights-hover-container">
            <button
                onClick={onClick}
                className="insights-refresh-new-btn"
                type="button"
            >
                New
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                >
                    <path
                        d="M12.793 2.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L14.086 7H12.5C8.952 7 6 9.952 6 13.5S8.952 20 12.5 20s6.5-2.952 6.5-6.5a1 1 0 1 1 2 0c0 4.652-3.848 8.5-8.5 8.5S4 18.152 4 13.5S7.848 5 12.5 5h1.586l-1.293-1.293a1 1 0 0 1 0-1.414z"
                    />
                </svg>
            </button>
            <span className="insights-hover-card">
                Figure is new or has changed since last refresh.
                <br />
                Do you want to refresh Insights?
            </span>
        </div>
    );
};
RefreshButtonNewData.propTypes = {
    onClick: PropTypes.func,
}

export const RefreshButtonStopGenerating = ({ onClick }) => {
    return (
        <div className="insights-hover-container">
            <button
                onClick={onClick}
                className="insights-stop-generating-btn"
                type="button"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 256 256"
                    style={{ marginLeft: '2px' }}
                >
                    <path
                        d="M216 55.27v145.46A15.29 15.29 0 0 1 200.73 216H55.27A15.29 15.29 0 0 1 40 200.73V55.27A15.29 15.29 0 0 1 55.27 40h145.46A15.29 15.29 0 0 1 216 55.27Z"
                    />
                </svg>
            </button>
            <span className="insights-hover-card">Stop Generating</span>
        </div>
    );
};
RefreshButtonStopGenerating.propTypes = {
    onClick: PropTypes.func,
}

export const RefreshButtonDefault = ({ onClick }) => {
    return (
        <div className="insights-hover-container">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                className="insights-hover-btn insights-refresh-btn"
                onClick={onClick}
            >
                <path d="M12.793 2.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L14.086 7H12.5C8.952 7 6 9.952 6 13.5S8.952 20 12.5 20s6.5-2.952 6.5-6.5a1 1 0 1 1 2 0c0 4.652-3.848 8.5-8.5 8.5S4 18.152 4 13.5S7.848 5 12.5 5h1.586l-1.293-1.293a1 1 0 0 1 0-1.414z" />
            </svg>
            <span className="insights-hover-card">
                Refresh Insights and conversation
            </span>
        </div>
    );
};
RefreshButtonDefault.propTypes = {
    onClick: PropTypes.func,
}
